import { DocumentNode } from "@apollo/client";
import {
    GET_ACHIEVEMENTS,
    GET_FINANCE_TYPES,
    GET_GAME_CONFIGURATION,
    GET_GAME_END,
    GET_LEGAL,
    GET_META_TAGS,
    GET_PHASES,
} from "@/utils/graphql/queries";

export interface StrapiEndpointConfig {
    /** Unique key to reference this data */
    key: string;
    /** GraphQL query document */
    query: DocumentNode;
    /** Optional variables for the query */
    variables?: Record<string, unknown>;
}

/**
 * Configure which Strapi queries to fetch during prebuild.
 * Add or remove entries as needed.
 */
export const strapiEndpoints: StrapiEndpointConfig[] = [
    { key: "phases", query: GET_PHASES },
    { key: "achievements", query: GET_ACHIEVEMENTS },
    { key: "gameConfiguration", query: GET_GAME_CONFIGURATION },
    { key: "financeTypes", query: GET_FINANCE_TYPES },
    { key: "legal", query: GET_LEGAL },
    { key: "metaTag", query: GET_META_TAGS },
    { key: "gameEnd", query: GET_GAME_END },
];
